import type { ReactNode } from "react";

/**
 * A framed note. Three tones, and the distinction between them is the point.
 *
 * `info`   — explains why a field exists.
 * `warn`   — an advisory finding: recorded, does not stop the application, but will be
 *            read by the administrator who verifies it.
 * `block`  — a blocking finding: the step cannot be left until it is fixed.
 *
 * Warn and block are drawn from different tokens so they cannot be mistaken for one
 * another at a glance. A warning that looks like a refusal teaches people to ignore
 * refusals.
 */

export type CalloutTone = "info" | "warn" | "block";

/**
 * Info is Green Wash, advisory is the default amber, refusal is Red Wash. Warn and block
 * are drawn from different families on purpose — a warning that looks like a refusal
 * teaches people to ignore refusals.
 */
const TONE: Record<CalloutTone, string> = {
  info: "callout green",
  warn: "callout",
  block: "callout red",
};

export function Callout({
  tone = "info",
  title,
  children,
}: {
  tone?: CalloutTone;
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className={TONE[tone]} role={tone === "info" ? undefined : "note"}>
      {title ? <b>{title}</b> : null}{title ? " " : null}
      {children}
    </div>
  );
}
